export default __webpack_public_path__ + "static/media/line.f73de171.svg";